import React from 'react'
import { connect } from 'react-redux'
import { doGetQualityFile, doSaveQualityFile, doDeleteQualityFile } from 'tyan/reducers/actions'
import { hasChangedValues, getFormValue, changeItemsValue } from 'tyan/public/utility/formValues'
import TreeSelect from '../../business/TreeSelect'
import DocumentDraftingDiv from './DocumentDrafting/DocumentDraftingDiv'
import DocumentRevisionDiv from './DocumentRevision/DocumentRevisionDiv'
import DocumentDestructionDiv from './DocumentDestruction/DocumentDestructionDiv'


class QualityFileDiv extends React.Component {
	state = {
	}

	SettingsDiv = {
		'文件起草': DocumentDraftingDiv,
		'文件修订': DocumentRevisionDiv,
		'文件销毁': DocumentDestructionDiv,
	}

	componentDidMount = () => {
		this.doGetQualityFile(this.props.id, this.props.fatherID)
	}

	doGetQualityFile = (id, fatherID) => {
		const { dispatch, } = this.props
		dispatch(doGetQualityFile({
			id: id || 0,
			fatherID: fatherID || 0,
			onEnd: ({ errorMessage, initValues基本信息, optionsParas }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				} else {
					if (!id && fatherID) {
						this.setState({ initValues基本信息: {}, changedValues基本信息: initValues基本信息, optionsParas })
					} else
						this.setState({ id, initValues基本信息, changedValues基本信息: {}, optionsParas })
				}
			}
		}))
	}

	handlerSave = () => {
		const { dispatch, onSave, onClose } = this.props
		const { id, initValues基本信息, changedValues基本信息, } = this.state
		var newValues = changedValues基本信息
		if (id <= 0) {
			newValues = { 'fatherID': initValues基本信息['fatherID'], 'fullName': initValues基本信息['fullName'], ...changedValues基本信息 }
		}
		dispatch(doSaveQualityFile({
			id,
			changedValues基本信息: newValues,
			onEnd: ({ errorMessage, id }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				} else {
					Ext.toast('保存成功')
					onSave && onSave()
					onClose && onClose()
				}
			}
		}))
	}

	handlerDelete = () => {
		const { dispatch, onClose, onSave } = this.props
		const { id } = this.state

		Tyan.pubForm.showConfirm('确定要删除？', () =>
			dispatch(doDeleteQualityFile({
				id,
				onEnd: ({ errorMessage }) => {
					if (errorMessage) {
						Tyan.pubForm.showError(errorMessage)
					}
					else {
						Ext.toast('删除成功')
						onSave && onSave()
						onClose && onClose()
					}
				}
			})))
	}

	handlerClose = () => {
		const { onClose, roles } = this.props
		if (!this.bChanged() || (roles.indexOf('权限管理员') == -1 && roles.indexOf('文件管理员') == -1)) {
			onClose && onClose()
			return
		}
		Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
	}


	canSave = () => {
		const { initValues基本信息, changedValues基本信息 } = this.state
		const values = { ...initValues基本信息, ...changedValues基本信息 }

		return this.bChanged() && getFormValue(this, '基本信息', '文件名称') &&
			getFormValue(this, '基本信息', '文件状态') &&
			getFormValue(this, '基本信息', 'fullName')
	}
	bChanged = () => {
		return hasChangedValues(this)
	}


	handleShowDiv = (initValues, onConfirm, onDelete) => {
		Tyan.pubForm.showDialog(initValues.title, props => <TreeSelect {...props} initValues={initValues} onConfirm={onConfirm} onDelete={onDelete} />)
	}

	handleShowLogDiv = (title, id) => {
		const Comp = this.SettingsDiv[title]
		Tyan.pubForm.showDialog(title, props => <Comp {...props} id={id} bReadOnly={true} />)
	}


	fieldset基本信息 = () => {
		const { roles } = this.props
		const { initValues基本信息, changedValues基本信息, optionsParas } = this.state
		const values = { ...initValues基本信息, ...changedValues基本信息, ...optionsParas }
		return [
			{ _text: '文件编号', name: '文件编号', minWidth: '40%' },
			{ _select: '文件状态', editable: true, minWidth: '40%', required: true },
			{ _text: '文件名称', required: true, minWidth: '90%' },
			{
				_text: '所属目录', name: 'fullName', minWidth: '40%', disabled: true,
				button: {
					text: "...",
					handler: () => this.handleShowDiv(
						{ title: '所属目录', ...values.arr目录, ...values.obj目录, treeName: values.treeName, treeField: values.treeField },
						(changedValues) => changeItemsValue(this, '基本信息', ['fatherID', 'fullName'], [changedValues['fatherID'], changedValues['fullName']]),
					),
					disabled: roles.indexOf('权限管理员') == -1 && roles.indexOf('文件管理员') == -1
				}
			},
			{ _text: '版别', minWidth: '40%' },
			{ _int: '修改次数', minWidth: '40%' },
			{ _text: '起草人', minWidth: '40%' },
			{ _date: '起草日期', minWidth: '40%' },
			{ _text: '发放范围', minWidth: '40%' },
			{ _files: '文件', multiple: false/*default*/, limit: 0/*default*/, minWidth: '90%', disabled: true },
			{ _text: '备注', minWidth: '90%', maxRows: 3 },

		]
	}

	fieldset文件日志 = () => {
		return [
			{
				_grid: '', name: '文件日志', rowNumbers: true, height: '100%',
				columns: [
					{ _text: '操作名称', minWidth: 100, },
					{ _text: '操作人', minWidth: 250, },
					{ _date: '操作时间', minWidth: 250, },
					{
						_button: '查看', icon: 'edit', minWidth: 150, flex: 1, handler: (data, record) =>
							this.handleShowLogDiv(record.操作名称, record.文件申请ID)
					},
				],
			},
		]
	}

	render() {
		const { showMessage: Message, showBody: Body, roles } = this.props
		const { errorMessage, id, initValues基本信息, changedValues基本信息 } = this.state
		if (errorMessage) return Tyan.pubForm.showError(errorMessage)
		if (!initValues基本信息) return <Message text={Tyan.t('请稍等 ...')} />
		return <Body data={this} maxWidth="1100"
			controls={
				[
					{ _button: this.bChanged() && (roles.indexOf('权限管理员') > -1 || roles.indexOf('文件管理员') > -1) && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
				]}
			fieldsets={
				[
					{ title: '基本信息', name: '基本信息', _fieldset: this.fieldset基本信息(), docked: 'top', heihgt: '60%', disabled: true },
					{ title: '文件日志', name: '基本信息', _fieldset: this.fieldset文件日志(), fullblock: true },
				]}
		/>
	}
}

export default connect()(QualityFileDiv)